import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveExcelSpreadsheetTemplates,
  submitCreateExcelSpreadsheetTemplate,
  submitUpdateExcelSpreadsheetTemplate,
  submitUpdateExcelSpreadsheetTemplatesVisibility
} from '~/api/data/excel-templates/mutations';
import {
  loadExcelSpreadsheetTemplate,
  loadExcelSpreadsheetTemplates
} from '~/api/data/excel-templates/queries';
import { ExcelTemplateEditPage, LibraryExcelTemplatesPage } from '~/pages/library/excel-templates';

const excelSpreadsheetTemplateLibraryChildren = [
  {
    path: 'archive',
    action: byMethod({
      POST: submitArchiveExcelSpreadsheetTemplates
    })
  },
  {
    path: 'visibility',
    action: byMethod({
      POST: submitUpdateExcelSpreadsheetTemplatesVisibility
    })
  },
  {
    // Uploads POST here from the dialog on the parent list page.
    path: 'new',
    action: byMethod({
      POST: submitCreateExcelSpreadsheetTemplate
    })
  },
  {
    path: ':id',
    loader: merge({
      excelSpreadsheetTemplate: loadExcelSpreadsheetTemplate
    }),
    action: byMethod({
      PUT: submitUpdateExcelSpreadsheetTemplate
    }),
    element: <ExcelTemplateEditPage />
  }
];

export const excelTemplatesRoute: RouteObject = {
  path: 'excel-templates',
  loader: merge({
    excelSpreadsheetTemplates: loadExcelSpreadsheetTemplates
  }),
  element: <LibraryExcelTemplatesPage />,
  children: excelSpreadsheetTemplateLibraryChildren
};
